module.exports = __webpack_public_path__ + "static/media/snapshot_onboarding_ios_1_2.9ceda405.png";